// TOP メインバナー — Splide フェードスライダー（画像 / 動画）

(function () {
  const homeSlide = document.getElementById('homeSlide');
  if (!homeSlide) return;

  const splide = new Splide(homeSlide, {
    type: 'fade',
    perPage: 1,
    autoplay: true,
    interval: 6000,
    speed: 1000,
    easing: 'linear',
    rewind: true,
    gap: '0',
    arrows: false,
    pagination: 'homeSlide-pagination',
    i18n: window.cmSplideI18n || {},
  });

  const toggle = homeSlide.querySelector('.splide__toggle');
  let userPaused = false;
  let advancingFromVideo = false;

  function handleZoomEnd(event) {
    event.target.classList.remove('is-zoom-animate');
  }

  function playZoomAnimation() {
    homeSlide.querySelectorAll('.splide__slide img').forEach((img) => {
      img.classList.remove('is-zoom-animate');
      img.removeEventListener('animationend', handleZoomEnd);
    });

    const activeImg = homeSlide.querySelector('.splide__slide.is-active img');
    if (!activeImg) return;

    void activeImg.offsetWidth;
    activeImg.classList.add('is-zoom-animate');
    activeImg.addEventListener('animationend', handleZoomEnd, { once: true });
  }

  function pauseAllVideos(reset) {
    homeSlide.querySelectorAll('[data-home-slider-video] video').forEach((video) => {
      video.pause();
      if (reset) {
        try {
          video.currentTime = 0;
        } catch (e) {
          // ignore seek errors before metadata
        }
      }
    });
  }

  function getVisibleVideo(slideEl) {
    if (!slideEl) return null;
    const videos = slideEl.querySelectorAll('[data-home-slider-video] video');
    if (!videos.length) return null;

    for (let i = 0; i < videos.length; i += 1) {
      if (window.getComputedStyle(videos[i]).display !== 'none') {
        return videos[i];
      }
    }

    return videos[0];
  }

  function getActiveSlideEl() {
    return homeSlide.querySelector('.splide__slide.is-active');
  }

  function setTogglePlaying(isPlaying) {
    if (!toggle) return;
    toggle.classList.toggle('is-active', isPlaying);
  }

  function syncActiveMedia() {
    const { Autoplay } = splide.Components;
    const activeSlide = getActiveSlideEl();
    const isVideoSlide = activeSlide && activeSlide.getAttribute('data-home-slider-media') === 'video';
    const video = isVideoSlide ? getVisibleVideo(activeSlide) : null;

    pauseAllVideos(true);

    if (video) {
      Autoplay.pause();

      if (userPaused) {
        setTogglePlaying(false);
        return;
      }

      setTogglePlaying(true);
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          // スライド切替や一時停止で中断された古い play() は無視する
          if (userPaused) return;
          if (getVisibleVideo(getActiveSlideEl()) !== video) return;
          Autoplay.play();
          setTogglePlaying(true);
        });
      }
      return;
    }

    playZoomAnimation();

    if (userPaused) {
      Autoplay.pause();
      setTogglePlaying(false);
      return;
    }

    Autoplay.play();
    setTogglePlaying(true);
  }

  function onVideoEnded(event) {
    const video = event.target;
    const slide = video.closest('.splide__slide');
    if (!slide || !slide.classList.contains('is-active')) return;
    if (userPaused) return;

    advancingFromVideo = true;
    splide.go('>');
  }

  homeSlide.querySelectorAll('[data-home-slider-video] video').forEach((video) => {
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.addEventListener('ended', onVideoEnded);
  });

  if (toggle) {
    // 動画スライドでは Splide Autoplay トグルと競合するため先に奪う
    toggle.addEventListener(
      'click',
      function (event) {
        const activeSlide = getActiveSlideEl();
        const video = getVisibleVideo(activeSlide);

        if (!video) {
          window.requestAnimationFrame(function () {
            userPaused = !toggle.classList.contains('is-active');
          });
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        const { Autoplay } = splide.Components;
        Autoplay.pause();

        if (video.paused) {
          userPaused = false;
          setTogglePlaying(true);
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          userPaused = true;
          setTogglePlaying(false);
          video.pause();
        }
      },
      true
    );
  }

  const mq = window.matchMedia('(min-width: 841px)');
  function onBreakpointChange() {
    const activeSlide = getActiveSlideEl();
    if (!activeSlide || activeSlide.getAttribute('data-home-slider-media') !== 'video') return;
    // PC/SP は別ファイルのため位置引き継ぎはせず、0秒から同期し直す
    syncActiveMedia();
  }

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', onBreakpointChange);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(onBreakpointChange);
  }

  splide.on('mounted', function () {
    syncActiveMedia();
  });

  splide.on('active', function () {
    if (advancingFromVideo) {
      advancingFromVideo = false;
      userPaused = false;
    }
    syncActiveMedia();
  });

  splide.on('move', function () {
    pauseAllVideos(false);
  });

  splide.mount();
})();
